<a mat-list-item (click)="toggle()">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Configurações">
            <mat-icon>settings</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Configurações</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- ACESSO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ACESSO)" icone="lock" titulo="Acesso" rota="acesso" toolTip="Acesso"></sub-menu>

        <!-- REGIÃO ADMINISTRATIVA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().REGIAO_ADMINISTRATIVA)" icone="layers" titulo="Região Administrativa" rota="regiaoadministrativa" toolTip="Região Administrativa"></sub-menu>
        
        <!-- USUARIO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().USUARIO)" icone="person_add" titulo="Usuário" rota="usuariosistema" toolTip="Usuário"></sub-menu>

        <!-- MODULO DA UNIDADE -->
        <sub-menu *ngIf="verificaAcesso(getModulos().GRUPO_MODULO)" icone="view_module" titulo="Módulos da Unidade" rota="grupomodulo" toolTip="Módulos da Unidade"></sub-menu>

        <!-- MODULO IMAGENS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().IMAGEM)" icone="image" titulo="Imagens" rota="imagem" toolTip="Imagens"></sub-menu>

        <!-- ALTERAR SENHA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ALTERAR_SENHA)" icone="cached" titulo="Alterar Senha" rota="novasenha" toolTip="Alterar Senha"></sub-menu>

        
        

    </div>
</mat-nav-list>
